import Vue from 'vue'
import { VIDEO_SEEK_MODES } from '../../const'

export default {
    namespaced: true,
    state: () => ({
        brightness: 1,
        playState: 'pause',
        skipFramesAmount: 1,
        invert: false,
        currentTimeCode_s: 0,
        seekBar_currentTimeCode_s: 0,
        currentRunIndex: 0,
        selectedMKEventSN: null,
        selectedIstanbulEventSN: null,
        selectedDaySN: null,
        isFertilizationCheck: false,
        videoSeekMode: VIDEO_SEEK_MODES.TIME,
        // Standalone Video
        standaloneVideoCurrentTime_H: null
    }),
    getters: {
        videoLength_s: (state, getters, rootState) => {
            if (!rootState.timelapse.selectedSlide) return 0

            return rootState.timelapse.selectedSlide.videoLength
        },
        videoFPS: (state, getters, rootState) => {
            if (!rootState.timelapse.selectedSlide) return 0

            return rootState.timelapse.selectedSlide.videoFPS
        },
        fpsCalibrationTime_s: (state, getters) => {
            if (!getters.videoFPS) return 0

            return Math.round((1 / getters.videoFPS / 2) * 1000000) / 1000000
        },
        numberOfRuns: (state, getters, rootState) => {
            if (!rootState.timelapse.selectedSlide) return 0

            return rootState.timelapse.selectedSlide.numberOfRuns
        },
        delayBetweenCycles_m: (state, getters, rootState) => {
            if (!rootState.timelapse.selectedSlide) return 0

            return rootState.timelapse.selectedSlide.delayBetweenCycles
        },
        availableMKEvents: (state, getters, rootState) => {
            if (!rootState.timelapse.selectedSlide) return []

            return rootState.timelapse.selectedSlide.availableMKEvents
        },
        slideIncubationLength: (state, getters, rootState) => {
            if (!rootState.timelapse.selectedSlide) return 0

            const nonEmptyWells = rootState.timelapse.selectedSlide.wells.filter(well => !!well)

            if (nonEmptyWells.length) {
                return nonEmptyWells[0].runs.last().time
            }

            return 0
        }
    },
    mutations: {
        playState(state, status) {
            state.playState = status
        },
        currentTimeCode_s(state, time) {
            state.currentTimeCode_s = time
        },
        seekBar_currentTimeCode_s(state, time) {
            state.seekBar_currentTimeCode_s = time
        },
        currentRunIndex(state, runIndex) {
            state.currentRunIndex = runIndex
        },
        selectedMKEventSN(state, eventSystemName) {
            state.selectedMKEventSN = eventSystemName
        },
        selectedIstanbulEventSN(state, eventName) {
            state.selectedIstanbulEventSN = eventName
        },
        selectedDaySN(state, day) {
            state.selectedDaySN = day
        },
        videoSeekMode(state, mode) {
            state.videoSeekMode = mode
        },
        isFertilizationCheck(state, isCheck) {
            state.isFertilizationCheck = isCheck
        },
        standaloneVideoCurrentTime_H(state, hour) {
            state.standaloneVideoCurrentTime_H = hour
        }
    },
    actions: {
        seek({ getters, commit }, { timecode, player }) {
            const videoFPS = getters.videoFPS
            const fpsCalibrationTime_s = getters.fpsCalibrationTime_s

            let modifiedTimecode = parseFloat(timecode.toFixed(2))

            let additionalTimeFraction =
                (Math.round(modifiedTimecode * 1000000) % Math.round((1 / videoFPS) * 1000000)) /
                1000000

            additionalTimeFraction = parseFloat(additionalTimeFraction.toFixed(4))

            if (additionalTimeFraction > 0) {
                modifiedTimecode = modifiedTimecode - additionalTimeFraction
            }

            modifiedTimecode += fpsCalibrationTime_s
            modifiedTimecode = parseFloat(modifiedTimecode.toFixed(2))

            if (player) {
                player.currentTime = modifiedTimecode
            } else {
                commit('currentTimeCode_s', modifiedTimecode)
                commit('seekBar_currentTimeCode_s', modifiedTimecode)
            }
        },
        skipToFrame({ state, getters, dispatch }, { frame, player = null, add = false }) {
            let desiredTimecode = frame / getters.videoFPS

            if (add) {
                let timecode = parseFloat(state.seekBar_currentTimeCode_s.toFixed(2))

                if (timecode > 0) {
                    const fpsCalibrationTime_s = getters.fpsCalibrationTime_s
                    timecode -= fpsCalibrationTime_s
                }
                desiredTimecode += timecode
            }
            dispatch('seek', { timecode: desiredTimecode, player })
        },
        skipFrame_forwardBackward({ state, dispatch }, { isForward }) {
            const frame = isForward ? state.skipFramesAmount : -state.skipFramesAmount

            dispatch('skipToFrame', { frame, add: true })
        },
        togglePlayStop({ state, commit }) {
            Vue.$log.videoEvent('play_stop')

            commit('playState', state.playState === 'play' ? 'pause' : 'play')

            if (state.playState === 'pause') {
                commit('currentTimeCode_s', state.seekBar_currentTimeCode_s)
            }
        },
        slideChangeCleanUp({ commit }) {
            commit('playState', 'pause')
            commit('videoSeekMode', 'time')
            commit('isFertilizationCheck', false)

            commit('selectedMKEventSN', null)
            commit('selectedIstanbulEventSN', null)
            commit('selectedDaySN', null)
        },
        resetSession({ state, commit }) {
            state.brightness = 1
            commit('playState', 'pause')
            state.skipFramesAmount = 1
            state.invert = false
            commit('videoSeekMode', 'time')
            commit('currentTimeCode_s', 0)
            commit('seekBar_currentTimeCode_s', 0)
            commit('selectedMKEventSN', null)
            commit('currentRunIndex', 0)
        },
        navigateBack({ commit }) {
            commit('videoSeekMode', 'time')
        }
    }
}
